<template>
	<div id="coverage-page">

		<section class="banner-section">
			<div class="container oversized-container">
				<div class="row align-items-center">
					<div class="col-12 col-title">
						<h5>Cobertura</h5>
					</div>
				</div>
			</div>
		</section>

		<section class="container info-section-1">
			<div class="row justify-content-center">
				<div class="col-lg-9 col-info">
					<h5 class="txt-lg">
						<!-- <strong class="txt-purple">BlackFon</strong> brinda la <span class="txt-purple">70.70%</span> de la población a través de infraestructura propia <span class="txt-purple">4.5G</span> y el resto del país de manera compartida por medio de otras redes disponibles. -->

						<strong class="txt-purple">BlackFon</strong> brinda la mejor cobertura nacional e internacional gracias a la tecnología <span class="txt-purple">Multi-Carrier</span> en México, Estados Unidos y Canadá, ofreciendo <span class="txt-purple">4.5G LTE Plus y  5G</span>, ya que contamos con infraestructura propia y además nos conectamos a otros operadores existentes.
					</h5>
				</div>
			</div>
		</section>

		<section class="info-section-2">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-lg-9 col-info">
						<p class="mb-2 text-center">
							<i class="fal fa-satellite icon"></i>
						</p>
						<h5 class="text-center txt-lg">
							<!-- Ofrecemos servicio <span class="txt-purple">4.5G para llamadas de alta calidad y la mejor experiencia de navegación</span> de forma universal, continua y no discriminatoria. -->
							Ofrecemos servicios <span class="txt-purple">4.5G LTE Plus en México y 5G en Estados Unidos y Canadá</span>, además de todo el poder del radio Prip®.
						</h5>
					</div>
				</div>
			</div>
		</section>

		<!-- <section class="info-section-4">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-12 col-extra-info">
						<div class="row justify-content-center">
							<div class="col-12 my-1 my-sm-3">
								<div class="t-250 _btn" target="_blank" @click="$refs.modalMap.show()">
									<i class="fal fa-satellite-dish satellite"></i><br />
									Conoce nuestra cobertura<br />en tu zona
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section> -->

		<iframe src="public/iframes/cobertura-w.html" class="cobertura no-overflow" width="100%" height="600px"></iframe>

		<!--  -->
		<!-- <b-modal modal-class="modal-map-s1" ref="modalMap" size="xl" centered hide-footer>
      		<iframe src="public/iframes/cobertura-w.html" width="100%" height="100%"></iframe>
    	</b-modal>  -->

	</div>
</template>

<script>
export default {
	data() {
		return {
			maps: [
				{
					icon: 'fal fa-satellite-dish',
					title: 'Actual',
					map: ''
				}
			]
		}
	},
}
</script>

<style lang="scss">
	.cobertura {
		padding: 0;
		overflow: hidden;
		height: calc(70vh + 6em);
		border: none;
	}
	
</style>